import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddClasses from "../../components/buttons/addClasses";
import "./Classes.css";
import AddClass from "./addClass";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRounded from "@mui/icons-material/DeleteRounded";

interface ClassesProps {
  allClasses: any[];
  onAddClass: (newClass: any) => void;
  onEditClass: (index: number, updatedClass: any) => void;
  onDeleteClass: (index: number) => void; // New prop for deletion
}

function Classes({ allClasses, onAddClass, onEditClass, onDeleteClass }: ClassesProps) {
  const [editIndex, setEditIndex] = React.useState<number | null>(null);

  const handleEditClick = (index: number) => {
    setEditIndex(index);
  };

  const handleDeleteClick = (index: number) => {
    if (window.confirm("Are you sure you want to delete this class?")) {
      onDeleteClass(index);
    }
  };

  return (
    <div className="allocateTableSize">
      <TableContainer component={Paper} className="p-3">
        <div className="d-flex justify-content-between">
          <h2 className="m-2 header-downTables-dashboard">Classes</h2>
          <AddClasses onAddClass={onAddClass} />
        </div>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow className="table-head-dashboard">
              <TableCell align="left">Class Title</TableCell>
              <TableCell align="left">Duration</TableCell>
              <TableCell align="left">Short Description</TableCell>
              <TableCell align="left">Thumbnail</TableCell>
              <TableCell align="left">Edit</TableCell>
              <TableCell align="left">Delete</TableCell> {/* New column */}
            </TableRow>
          </TableHead>
          <TableBody>
            {allClasses.map((cls, index) => (
              <TableRow
                hover={true}
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">{cls.title}</TableCell>
                <TableCell align="left">{cls.minDuration} min</TableCell>
                <TableCell align="left">{cls.description}</TableCell>
                <TableCell align="left">{cls.thumbnailImageUrl}</TableCell>
                <TableCell align="left">
                  <EditRoundedIcon
                    style={{ color: "#8E8EA1", cursor: "pointer" }}
                    onClick={() => handleEditClick(index)}
                  />
                </TableCell>
                <TableCell align="left">
                  <DeleteRounded
                    style={{ color: "#FF0000", cursor: "pointer" }}
                    onClick={() => handleDeleteClick(index)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {editIndex !== null && (
        <AddClass
          handleClose={() => setEditIndex(null)}
          onAddClass={(updatedClass) => {
            onEditClass(editIndex, updatedClass);
            setEditIndex(null);
          }}
          initialData={allClasses[editIndex]}
        />
      )}
    </div>
  );
}

export default Classes;